import styled from "styled-components";

export default styled.div`
  width: 100%;
  background: linear-gradient(90deg, #ff7369 0%, #d83848 111.81%);
  padding: 1.5rem 2.5rem;
  color: ${(props) => (props.disabled ? "#F9F8F5" : "#FFFFFF")};
  cursor: ${(props) => (props.disabled ? "help" : "pointer")};
  border-radius: 5px;
  text-align: center;

  &:hover {
    background: ${(props) => (props.disabled ? "#09100F" : "#ED3825")};
  }

  &.btn-primary {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    background: linear-gradient(90deg, #ff7369 0%, #d83848 111.81%);
    &:hover {
      background: #09100F;
    }
  }

  &.btn-secondary {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    background: #09100F;
    &:hover {
      background: linear-gradient(90deg, #ff7369 0%, #d83848 111.81%);
    }
  }

  &.btn-primary-outline {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: center;
    background: none;
    padding: 12px 18px;
    border: 1px solid #09100F;
    color: #09100F;
    display: inline-block;
    width: auto !important;
    &:hover {
      background: #09100F;
      color: #FFFFFF;
    }
  }
`;
